import { FC, useContext, useEffect, useState } from "react";

import { AuthContext } from "../../../../contexts/AuthContext";

import {
    getTagsByUser,
    removeTagsFromUsers,
} from "../../../../services/api/admin/tags";
import Tag from "../../../../components/Tag";
import { Tag as TagType } from "../../../../types/api/admin/tag";

import styles from "./styles.module.scss";
import { toast } from "react-toastify";

type Props = {
    user: { id: string };
};

const Tags: FC<Props> = ({ user }) => {
    const { hasPermission } = useContext(AuthContext)!;

    const [tags, setTags] = useState<TagType[] | undefined>();

    const handleRemoveTag = (tagId: string) => {
        removeTagsFromUsers([user.id], [tagId])
            .then(() => {
                setTags((prevTags) =>
                    prevTags?.filter((tag) => tag.id !== tagId)
                );
                toast.success("Tag retiré avec succès");
            })
            .catch((error) => {
                console.error("Error removing tag:", error);
                toast.error("Erreur lors du retrait du tag");
            });
    };

    useEffect(() => {
        getTagsByUser(user.id).then((tags) => {
            setTags(tags);
        });
    }, [user.id]);

    return (
        <div className={styles.tags}>
            {tags &&
                tags.length > 0 &&
                tags.map((tag) => (
                    <Tag
                        key={tag.id}
                        onRemove={
                            hasPermission("admin-tags", "delete")
                                ? () => handleRemoveTag(tag.id)
                                : undefined
                        }
                    >
                        {tag.name}
                    </Tag>
                ))}
        </div>
    );
};

export default Tags;
